import PropTypes from "prop-types";
import React from "react";
import styles from "./feeds-seo-most-wanted.css";

function FeedsSeoMostWanted({ mostWanted }) {
    return (
        <div className={styles.mostWanted}>
            <h3>{mostWanted.title}</h3>
            <ul>
                {mostWanted.items.map((item, index) => {
                    return (
                        <li className={styles.mostWantedItem} key={index}>
                            <figure className={styles.mostWantedFigure}>
                                <img className={styles.mostWantedImg} src={item.img} />
                            </figure>
                            <div>
                                <h3 className={styles.mostWantedTitle}>{item.title}</h3>
                                <p
                                    className={styles.mostWantedBody}
                                    dangerouslySetInnerHTML={{ __html: item.body }}
                                />
                                <a href={item.link} className={styles.mostWantedPricing}>
                                    {item.pricing}
                                </a>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

FeedsSeoMostWanted.propTypes = {
    mostWanted: PropTypes.object,
};

export default FeedsSeoMostWanted;
